import axiosV1 from "@/plugins/axios/configV1";

export default {
    getDownloadLogs(params = {}) {
        return axiosV1.get("settings/download/data/log", { params });
    },
    exportDownloadLogs(params = {}) {
        return axiosV1.get("settings/export/data/log", { params });
    },
};
